// extracted by mini-css-extract-plugin
module.exports = {"article__panel":"styles_article__panel__HEhAa","panel__title":"styles_panel__title__bpQi_"};